<template lang="html">
  <section class="popup specialization">
    <div class="popup-wrapper">

      <div class="popup-header">
        {{headerText}}
      </div>
      <div class="popup-container">
        <h5 v-if="specialization == 'hivatalos_szemelyes_okirat'">
          Válassza ki a fordításra szánt dokumentumot.<br>
          Amennyiben az nem szerepel a lenti listán, válassza az „Egyéb” lehetőséget
        </h5>
        <div class="popup-ico-box">
          <div class="popup-radio-input" v-for="(option, optKey) in options" :key="optKey">
            <input
              type="radio"
              v-model="subOption"
              :value="optKey"
              :id="'spec-popup-'+optKey"
              @click="closeWithDelay(optKey)"
            />
            <label :for="'spec-popup-'+optKey">
              <div class="popup-option-box">
                <img
                class="popup-option-icon"
                v-if="getIcon(optKey)"
                :src="getIcon(optKey)"
                />
                <span class="popup-option-text">
                  {{option.label}}
                </span>
                <div class="popup-option-sample" v-if="getSampleUrl(optKey)">
                  <a target="_blank" :href="getSampleUrl(optKey)">minta</a>
                </div>
              </div>
            </label>
          </div>
        </div>
        <div class="other-doctype" v-if="customDoctypeEnabled" style="display: none; width: 0px; height: 0px;">
          <label for="spec-popup-egyeb"></label> <br>
          <input
            type="text"
            v-model="customDocType"
            id="spec-popup-egyeb"
          />
        </div>
      </div>
      <div class="popup-footer">
        <button
          type="button"
          @click="close()"
        >
          Bezárás
        </button>
      </div>
    </div>
  </section>

</template>

<script>
export default {
  data: function(){
    return {
      'docType$': '',
      'customDocType$': ''
    }
  },
  props: [
    'options',
    'show',
    'docType',
    'specialization',
    'documentsSample'
  ],
  computed: {
    subOption: {
      set(val) {
        this.docType$ = val
        if(this.customDoctypeIsEnabled(val)) {
          this.$emit('update:docType', this.customDocType$)
        } else {
          this.$emit('update:docType', val)
        }
      },
      get() {
        return this.docType$
      }
    },
    customDocType: {
      set(val) {
        this.customDocType$ = val
        if(this.customDoctypeEnabled) {
          this.$emit('update:docType', val)
        }
      },
      get() {
        return this.customDocType$
      }
    },
    customDoctypeEnabled() {
      return this.customDoctypeIsEnabled(this.docType$)
    },
    headerText() {
      return 'Dokumentum típusának kiválasztása';
    }
  },
  methods: {
    close() {
      this.$emit('update:show', false)
    },
    // A hivatalos iratok felugró listából ha kiválasztunk egy elemet, késleltetjük a callback-et, hogy
    // látszódjon a kiválasztott állapot (kéken emelődik ki a kiválasztott opció) 1mp-ig és utána triggerelődik
    // a callback és zárja be a felugró ablakot
    closeWithDelay(optKey) {
      // Kiszedve: más irat opció választása esetén ne zárja be az ablakot, mert a felhasználónak be kell írnia az egyedi kategóriát egy szöveg mezőbe
      if (optKey) {
        setTimeout( () => { this.close() }, 750 )
      }
    },
    customDoctypeIsEnabled(val) {
      return val == 'mas_irat' || val == "egyeb_cegjegyzekbe_bejegyzendo_irat"
    },
    getIcon(key) {
      return typeof this.documentsSample[key + '-minta'] != "undefined" ? this.documentsSample[key + '-minta']["featured_image_url"] : null
    },
    getSampleUrl(key) {
      return typeof this.documentsSample[key + '-minta'] != "undefined" ? this.documentsSample[key + '-minta']["url"] : null
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/sass/_variables';
.popup.specialization{
  display: flex;
  position: fixed;
  align-content: center;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  background: rgba(255,255,255,0.65);
  width: 100%;
  max-width: 100vw;
  box-sizing: border-box;
  min-height: 100vh;
  z-index: 99;
  .popup-wrapper{
    width: 500px;
    background: white;
    box-shadow: 5px 5px 25px rgba(0,0,0,.4);
    border-radius: 5px;
    overflow-y: auto;
    padding-bottom: 5px;
    max-height: 100vh;
  }
  .popup-header, .popup-container{
    padding: .5em 1em;
  }
  .popup-header{
    font-size: 1.2em;
    white-space: pre;
  }
  .popup-container{
    font-size: 1.15em;
  }
  .popup-footer{
    margin-top: 2em;
    padding: .5em .8em;
    text-align: right;
    button{
      background: $primary-color;
      height: 40px;
      line-height: 40px;
      text-transform: capitalize;
    }
  }
  .other-doctype{
    margin-top: 1.5em;
    label{
      font-weight: normal;
    }
  }
  #spec-popup-egyeb{
    width: 80%;
  }
  .popup-option-icon {
    max-height: 4em;
  }
  .popup-ico-box{
    display: flex;
    flex-wrap: wrap;
    .popup-option-sample {
      text-align: right;
      a{
        color: $secondary-color;
        &:hover{
          text-decoration: underline;
        }
      }
    }
    .popup-radio-input {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      [type="radio"] {
        display: none;
      }
      [type="radio"]+label{
        margin: 2px;
        width: 100%;
        font-weight: normal;
        font-size: 14px;
        line-height: 1.3em;
        padding: .7em 1em;
        border: 1px solid $default-box-border-color;
        background-color: $default-box-bg-color;
        color: $default-box-text-color;
        .popup-option-box{
          display: flex;
          .popup-option-sample{
              flex-grow: 1;
          }
        }
        .popup-option-icon{
          //betűmérethez igazodó magasság
          max-height: 2em;
          margin-right: 1em;
        }
      }
      [type="radio"]:checked+label{
        border-color: $selected-box-border-color;
        background-color: $selected-box-bg-color;
        transition: all .3s;
      }
    }

  }
}
</style>
